import React from 'react'

export default ({ icon, title, desc, id }) => {
  return <div className={`col-lg-6 col-md-12 col-sm-12 ${id > 0 ? 'feature-mobile' : ''}`}>
    <div className="row align-items-center">
      <div className="text-center mt-3 col-md-3 col-sm-12">
        {/* <div className="icon-wrap featureIcons" dangerouslySetInnerHTML={{ __html: icon }} /> */}
        <img src={icon} className="feature-image" alt={title} title={title} />
      </div>
      <div className="col-md-9 mt-3 col-sm-12">
        <h3 className="fw-500">{title}</h3>
        <p className="lead fz-15 text-dark-gray mb-0">{desc}</p>
      </div>
    </div>
    <div className="lg-space mobile"></div>
  </div>
}
